import theme from "src/themeNew";

const styles = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    padding: '20px',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '24px',
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
  },
  title: {
    color: theme.palette.text.primary,
    fontSize: '18px',
    fontWeight: '500',
    lineHeight: '28px',
  },
  subtitle: {
    color: theme.palette.text.primary,
    fontSize: '15px',
    fontWeight: '500',
    lineHeight: '22px',
  },
  addIcon: {
    color: theme.palette.text.white,
    height: '18px',
    width: '18px',
  },
};

export default styles;
